import AboutMuseum from "components/common/dl_group/introduction/AboutMuseum";
import SavaSumanovic from "components/common/dl_group/introduction/SavaSumanovic";
import Avangarda from "components/common/dl_group/introduction/Avangarda/Avangarda";
import ConceptualArt from "components/common/dl_group/introduction/ConceptualArt/ConceptualArt";
import OctoberSalon from "components/common/dl_group/introduction/OctoberSalon";
// import PetarLubarda from "components/common/dl_group/introduction/PetarLubarda";
// import NadezdaPetrovic from "components/common/dl_group/introduction/NadezdaPetrovic";
import NadezdaPetrovic from "components/common/dl_group/introduction/NadezdaPetrovic/NadezdaPetrovic";
import PetarLubarda from "components/common/dl_group/introduction/PetarLubarda/PetarLubarda";

import { DL_GROUPS } from "constant/dl_group/dl_group.constant";
import { useParams } from "react-router-dom";

export default function GroupIntroduction() {
  const { slug } = useParams();

  if (!slug) {
    return <></>;
  }

  return (
    <>
      {slug === DL_GROUPS["muzej-savremene-umetnosti"].slug && <AboutMuseum />}
      {slug === DL_GROUPS["petar-lubarda"].slug && <PetarLubarda />}
      {slug === DL_GROUPS["sava-sumanovic"].slug && <SavaSumanovic />}
      {slug === DL_GROUPS["nadezda-petrovic"].slug && <NadezdaPetrovic />}
      {slug === DL_GROUPS["avangarda"].slug && <Avangarda />}
      {slug === DL_GROUPS["oktobarski-salon"].slug && <OctoberSalon />}
      {slug === DL_GROUPS["konceptualna-umetnost"].slug && <ConceptualArt />}
    </>
  );
}
